import { fg } from '@atlaskit/platform-feature-flags';

import { AI_MATE_EXPERIENCE_ID, FEEDBACK_COLLECTOR_ENTRYPOINT_ID } from '../../constants/private';

import { serviceProductToProductKey } from './serviceProductToProductKey';
import type { GlobalConfig, CreateGlobalConfigArgs } from './types';

export const createGlobalConfig = ({
	profileData,
	displaySubmitFlag,
	siteId,
	product,
	experienceId = AI_MATE_EXPERIENCE_ID,
	workspaceId,
	orgId,
	assistanceServiceConfig,
	closeChat,
	emojiProvider,
	preventAbortRequestsOnStagingModalClose,
	preventAbortRequestsOnStandaloneChatClose,
	renderingTouchpoint,
	inProductExperience,
	smartCreationContext,
	jiraIssueCommentEditor,
	autocompletePageContentSource,
	editorContentIdResolver,
}: CreateGlobalConfigArgs): GlobalConfig => ({
	profileData,
	feedbackCollector: {
		entryPointId: FEEDBACK_COLLECTOR_ENTRYPOINT_ID,
		displaySubmitFlag,
	},
	siteId,
	experienceId,
	workspaceId,
	productKey: serviceProductToProductKey(product),
	productHeader: product,
	orgId,
	assistanceServiceConfig,
	closeChat,
	emojiProvider,
	preventAbortRequestsOnStagingModalClose,
	preventAbortRequestsOnStandaloneChatClose,
	...(fg('fe_enable_sa_externally') && { renderingTouchpoint }),
	inProductExperience,
	smartCreationContext,
	jiraIssueCommentEditor,
	autocompletePageContentSource,
	editorContentIdResolver,
});
